import { useQuery } from '@tanstack/react-query'
import type { CurrentUser } from '@/types'
import { apiGet } from '@/lib/api'
import { apiUserToCurrentUser, type ApiUser } from '@/lib/adapters'

export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const res = await apiGet<{ user: ApiUser }>('/auth/me')
      return apiUserToCurrentUser(res.user)
    },
    staleTime: 60_000,
    retry: false, // 401 → la api lib redirige a /login automáticamente
  })
}
